import axios from "../axios";

const getBankAccounts = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('/bank-account/getBankAccounts',params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBankAccounts;
